// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  padding: 30px;\n}\n.error-page-wrap .close-button {\n  position: absolute;\n  top: 22px;\n  right: 22px;\n  min-width: inherit !important;\n}\n.error-page-wrap .svg-icon {\n  max-width: 90vw;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
